// Module
var code = "<h1 id=\"my-homeclasses\">My HomeClasses</h1> <p>This is a list of homeclasses for students who are linked to their selected campus.</p> <p>By clicking on a homeclass, users can view the list of students and their details, profile, enrolments, guardians and services.</p> <p>The list can also be downloaded for printing.</p> ";
// Exports
module.exports = code;